const BaseView = require('./view');
module.exports = BaseView.extend({

    onConfirm(e) {
        e.preventDefault();
        e.stopPropagation();

        this.track('onConfirm');
        this.toggleChildLayer(false);
    },
});
